
var React = require("react");
var DataComponent = require("./DataComponent.jsx");

const CircuitsUtil = require('../util/CircuitsUtil');

const PAGE_SIZE = 24;

class PaginationDataComponent extends DataComponent {

    componentDidMount(){
        super.componentDidMount()
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
    }

    changePage(page) {
        if(this.props.onPageChangeHandler) {
            this.props.onPageChangeHandler(page + 1);
        }
    }

    get pageSize() {
        return this.props.pageSize || PAGE_SIZE;
    }

    getDataUrl(props) {
        var pageSize, pageIndex;

        if (pageSize == undefined) {
            pageSize = this.props.pageSize || this.pageSize;
        }

        if (pageIndex == undefined) {
            pageIndex = props.pageIndex || 0;
        }

        var start = pageIndex * pageSize;

        var urlPrefix = props.dataUrl;
        if (urlPrefix) {
            if (/\?/.test(urlPrefix)) {
                if (CircuitsUtil.isLibraryQueryEndpoint(urlPrefix)) urlPrefix += `&${CircuitsUtil.getLibraryQueryFields()}`;
                return `${urlPrefix}&start=${start}&rows=${pageSize}`;
            } else {
                return `${urlPrefix}?start=${start}&rows=${pageSize}`;
            }
        } else {
            return undefined;
        }
    }

}

module.exports = PaginationDataComponent;
